







import {defineComponent, onMounted, PropType, watch} from "@vue/composition-api"
import {MyStudyChoiceOnboardingModelState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import {useActions, useGetters} from "vuex-composition-helpers"
import {ActionTree, GetterTree} from "vuex"
import {Labels} from "@/apps/MyStudyChoiceOnboardingWidget/models/config-viewmodel"
import OnboardingModal from "./components/OnboardingModal.vue"
import CloseNotificationModal from "./components/CloseNotificationModal.vue"
import StepCollection from "@/apps/MyStudyChoiceOnboardingWidget/statics/StepCollection";
import {useOnboardingExchangeBus} from "@/shared/composables/onboardingExchangeBus";

export default defineComponent({
    name: "MyStudyChoiceOnboardingWidget",
    components: {
        OnboardingModal,
        CloseNotificationModal,
    },
    props: {
        labels: {
            type: Object as PropType<Labels>,
            required: true
        },
        initialize: {
            type: Boolean,
            required: true
        },
        eventListener: {
            type: String,
            required: false
        },
        flow: {
            type: String,
            required: true,
            default: 'internal',
            validator: (value: string) => {
                return ['internal', 'external'].includes(value);
            }
        }
    },
    setup: (props) => {
        const {
            setLabels, setSteps, setOnboardingIsActive, setOnboardingIsCompleted
        } = useActions<ActionTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'setLabels', 'setSteps', 'setOnboardingIsActive', 'setOnboardingIsCompleted'
        ]);

        const {
            getOnboardingIsActive, getOnboardingIsCompleted
        } = useGetters<GetterTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'getOnboardingIsActive', 'getOnboardingIsCompleted'
        ]);
        setLabels(props.labels)
        setSteps(StepCollection[props.flow as keyof Object])

        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        const onboarding = urlParams.get('onboarding')
        
        function init(): void {
            if(getOnboardingIsActive.value && !getOnboardingIsCompleted.value) return
            setOnboardingIsActive(true)
            setOnboardingIsCompleted(false)
        }

        function addListener(eventListener: string): void {
            document.querySelectorAll(eventListener).forEach((el) => {
                el.addEventListener('click', (event: any) => {
                    init()
                })
            })
        }


        watch(
            () => useOnboardingExchangeBus().active,
            (newState, oldState) => {
                if(newState) {
                    init()
                    useOnboardingExchangeBus().active = false
                }
            }
        )

        onMounted(async () => {
            let isShown = localStorage?.getItem('my-study-choice-onboarding');
            if (!isShown && props.initialize) {
                init()
            }
            if (onboarding) {
                init()
            }
            if (!props.eventListener) return
            addListener(props.eventListener)
            document.addEventListener("DOMNodeInserted", () => {
                if (!props.eventListener) return
                addListener(props.eventListener)
            })
        })
        
        return {
            getOnboardingIsActive,
            getOnboardingIsCompleted
        }
    }
})
